/* eslint-disable operator-linebreak */
/* eslint-disable indent */
/* eslint-disable object-curly-newline */
/* eslint class-methods-use-this: 0 */
/* eslint max-len: 0 */
/* eslint camelcase: 0 */
import Client from './Client';
// eslint-disable-next-line import/no-cycle
import MapMarkers from './MapMarkers';
import MapUtils from './MapUtils';
import {
  i18n,
  getNodeHeight,
  animateDirectionsComponent,
  animateDestinationChargerComponent,
} from './Utils';
import {
  DRAGGABLE_DIRECTIONS,
  DRAGGABLE_DESTINATION_CHARGERS,
  LIST,
  INFO_WINDOW,
  TSLA_HEADER_MAIN,
} from './Constants';
import Enliven from './Enliven';

class MapWindow {
  constructor() {
    this.overlay = {};
    this.currentSelectedMarker = null;
    this.centerChangedListener = null;
    this.boundsChangedListener = null;
  }

  /**
   * @description Instantiates an overlay for display custom elements on top of the map
   *
   * @return {void}
   */
  initOverlayView() {
    const { google, map } = window;

    google.maps.event.addListener(map, 'projection_changed', () => {
      this.overlay = new google.maps.OverlayView();
      this.overlay.draw = () => { };
      this.overlay.setMap(map);
    });
  }

  /**
   * @description Displays custom error message in the map info window
   *
   * @param {Object} marker - Map marker object
   * @param {boolean} isMobile - If the user is on a handheld device
   * @param {Object} e - Event object
   * @param {Object} position - LatLng object
   *
   * @return {void}
   */
  displayErrorMessage({ marker, isMobile, e, position, ErrorMsg }) {
    const chargerDetails = `<p>${ErrorMsg}</p>`;
    this.bindInfoWindowListeners(marker, chargerDetails, isMobile);

    const pos = this.overlay
      .getProjection()
      .fromLatLngToContainerPixel(e.latLng);
    this.positionInfoWindow(pos, chargerDetails, isMobile);
    this.openInfoWindow(isMobile);

    MapUtils.panToMapMarker(position);

    MapMarkers.resetSelectedMarkers();
  }

  /**
   * @description Constructs charger details to display in map info window
   *
   * @param {Object} superChargerSite - Charger details (location, siteName, amenities)
   * @param {Object} trtLocation - Address details
   * @param {boolean} isMobile - If the user is on a handheld device
   * @param {string} content - Additional content to append to API results
   *
   * @return {string} formatted and marked up charger details
   */
  constructChargerDetails({
    superChargerSite,
    trtLocation,
    isMobile,
    content,
  }) {
    let chargerDetails = [
      // eslint-disable-next-line operator-linebreak
      `<h1><i class="tsla-icon-angle_left"></i>${superChargerSite.location ||
      superChargerSite.siteName}</h1>`,
      '<div class="details">',
    ];
    const address = trtLocation
      ? this.constructChargerAddress(trtLocation)
      : this.constructDestinationChargerAddress(superChargerSite, isMobile);
    chargerDetails.push(address);
    const amenities = this.constructChargerAmenities(content, superChargerSite);
    chargerDetails = chargerDetails.concat(amenities).join('');

    return chargerDetails;
  }

  /**
   * @description Formats supercharger address
   *
   * @param {Object} trtLocation - Address details
   *
   * @return {string} formatted address
   */
  constructChargerAddress(trtLocation) {
    const address = `
      <p class="address">
        ${trtLocation.name}<br/>
        ${trtLocation.address.street}<br/>
        ${trtLocation.address.city}, ${trtLocation.address.stateprovince ||
      ''} ${trtLocation.address.postalcode || ''}
      </p>
    `;

    return address;
  }

  /**
   * @description Formats destination charger address
   *
   * @param {Object} details - Address details
   * @param {boolean} isMobile - If the user is on a handheld device
   *
   * @return {string} formatted address
   */
  constructDestinationChargerAddress(details, isMobile) {
    const address = `
      <p class="address">
        ${details.siteName || ''}<br/>
        ${details.streetNumber || ''} ${details.streetName || ''}
        ${
      details.city || details.state || details.zipPostalCode
        ? `<br/>${details.city || ''}, ${details.state ||
        ''} ${details.zipPostalCode || ''}`
        : ''
      }
        ${
      !isMobile
        ? `<br/><a href="${
        details.website
        }" class="tp-text-wrap" target="_blank">${
        details.website
        }</a><br/>`
        : ''
      }
      </p>
    `;

    return address;
  }

  /**
   * @description Formats supercharger & destination charger amenities
   *
   * @param {string} chargerBody - Location details
   * @param {Object} chargerDetails - More charger details
   *
   * @return {string} formatted amenities
   */
  constructChargerAmenities(chargerBody, chargerDetails) {
    const superchargerDetails = this.appendChargerConnectorDetails({
      chargerBody,
      chargerDetails,
    });

    let amenities = [];
    if (chargerDetails.checkboxRestrooms) {
      amenities.push('<i class="tsla-icon_map--bathroom"></i>');
    }

    if (chargerDetails.checkboxWifi) {
      amenities.push('<i class="tsla-icon_map--wifi"></i>');
    }

    if (chargerDetails.checkboxRestaurant || chargerDetails.checkboxCafe) {
      amenities.push('<i class="tsla-icon_map--restaurant"></i>');
    }

    if (chargerDetails.checkboxLodging) {
      amenities.push('<i class="tsla-icon_map--hotel"></i>');
    }

    if (chargerDetails.checkboxShopping) {
      amenities.push('<i class="tsla-icon_map--shopping"></i>');
    }

    amenities = `<span class="icons">${amenities.join(
      '',
    )}</span>${superchargerDetails}</div>`;

    return amenities;
  }

  /**
   * @description Appends supercharger & destination charger connector details to info window
   *
   * @param {string} chargerBody - Location details
   * @param {Object} chargerDetails - More charger details
   *
   * @return {string} charger connector details
   */
  appendChargerConnectorDetails({ chargerBody, chargerDetails }) {
    let superchargerDetails = '';

    if (chargerDetails.wallConnectorsInstalled) {
      if (chargerDetails.wallConnectorsInstalled > 1) {
        superchargerDetails = `<div class="chargers">${i18n(
          chargerBody.plural,
          {
            CHARGERS:
              chargerDetails.totalInstalledConnectors ||
              chargerDetails.wallConnectorsInstalled ||
              chargerDetails.connectorsInstalled,
            KILOWATTS: chargerDetails.kilowatts,
          },
        )}
          </div>`;
      } else {
        superchargerDetails = `<div class="chargers">${i18n(
          chargerBody.singular,
          {
            CHARGERS:
              chargerDetails.totalInstalledConnectors ||
              chargerDetails.wallConnectorsInstalled ||
              chargerDetails.connectorsInstalled,
            KILOWATTS: chargerDetails.kilowatts,
          },
        )}
          </div>`;
      }
    } else {
      superchargerDetails = `<div class="chargers">${i18n(chargerBody, {
        CHARGERS:
          chargerDetails.totalInstalledConnectors ||
          chargerDetails.wallConnectorsInstalled ||
          chargerDetails.connectorsInstalled,
        KILOWATTS: chargerDetails.kilowatts,
      })}
          </div>`;
    }

    return superchargerDetails;
  }

  /**
   * @description Handles opening charger info window
   *
   * @param {Object} e - Event object
   * @param {Object} place - Location details
   * @param {integer} place.id - Unique identifier for location
   * @param {Object} position - LatLn object
   * @param {Object} marker - Map marker object
   * @param {string} chargerDetails - Additional content to append to API results
   * @param {boolean} isMobile - If the user is on a handheld device
   *
   * @return {void}
   */
  handleInfoWindow({ marker, chargerDetails, isMobile, e, position }) {
    const { map } = window;
    const pos = this.overlay
      .getProjection()
      .fromLatLngToContainerPixel(map.getCenter());
    this.positionInfoWindow(pos, chargerDetails, isMobile);

    if (this.currentSelectedMarker) {
      // reset previously selected markers
      MapMarkers.resetSelectedMarkers(this.centerChangedListener, this.boundsChangedListener);
    }

    this.currentSelectedMarker = marker;

    // pan to map marker
    MapUtils.panToMapMarker(position);

    // nudge the map a little bit to make certain the info window is positioned correctly
    if (isMobile && getNodeHeight(TSLA_HEADER_MAIN)) {
      map.panBy(0, Math.round(getNodeHeight(INFO_WINDOW) / 2));
    }

    this.openInfoWindow(isMobile, e.source || null);

    // Delays the binding of the map listener to avoid conflicting with the panning movement.
    // eslint-disable-next-line prefer-arrow-callback
    setTimeout(function delayedbindMapListener() {
      this.bindInfoWindowListeners(marker, chargerDetails, isMobile);
    }.bind(this), 10);
  }

  /**
   * @description Fetches supercharger or destination charger details from locations API
   *
   * @param {Object} e - Event object
   * @param {Object} place - Location details
   * @param {integer} place.id - Unique identifier for location
   * @param {Object} position - LatLn object
   * @param {Object} marker - Map marker object
   * @param {string} content - Additional content to append to API results
   * @param {boolean} isMobile - If the user is on a handheld device
   *
   * @return {void}
   */
  getChargerDetails({
    e,
    place,
    position,
    marker,
    content,
    isMobile,
    errorMsg,
  }) {
    // preemptively open the charger window with a loading spinner until fetch resolves
    let chargerDetails = '<div class="section-loader"></div>';
    if (isMobile) {
      this.handleInfoWindow({ marker, chargerDetails, isMobile, e, position });
    }

    Client.fetchChargerDetails(place.id, (err, res) => {
      if (err) {
        this.displayErrorMessage({ marker, isMobile, e, position, errorMsg });
      } else {
        const charger = res.body.responseObject;
        const superChargerSite =
          charger.superChargerSite || charger.destinationChargerSite;
        const { trtLocation } = charger;

        chargerDetails = this.constructChargerDetails({
          superChargerSite,
          trtLocation,
          isMobile,
          content,
        });

        // handle opening of charger window
        this.handleInfoWindow({
          marker,
          chargerDetails,
          isMobile,
          e,
          position,
        });

        // change icon to selected icon
        MapMarkers.swapIcon({ marker, trtLocation, place });

        // Push charger type analytics
        MapUtils.chargerAnalytics({ e, trtLocation });
      }
    });
  }

  /**
   * @description Positions the info window depending on the x & y coordinates of a marker
   *
   * @param {Object} pos - Position details
   * @param {Object} pos.x - X coordinate
   * @param {Object} pos.y - Y coordinate
   * @param {string} content - Content to display in an info window
   * @param {boolean} isMobile - If the user is on a handheld device
   *
   * @return {void}
   */
  positionInfoWindow(pos, content, isMobile) {
    const info = document.getElementById('info-window');
    const child = info.childNodes[0];

    child.innerHTML = null;
    child.innerHTML = content;

    const infoWindowHeight = child.offsetHeight === 0 ? 205 : child.offsetHeight;


    if (isMobile) {
      try {
        const closeBtn = info.childNodes[0].childNodes[0].childNodes[0];
        closeBtn.addEventListener('click', () => {
          this.closeInfoWindow(isMobile);
        });
      } catch (e) {
        // console.log('trying to bind event listener to node that is not yet part of the DOM');
      }
    }

    info.style.position = 'absolute';

    if (!isMobile) {
      info.style.left = `${pos.x + 182}px`;
      info.style.top = `${pos.y - infoWindowHeight - 30}px`;
    }

    // add loading classname to node so that user cannot close the window while it is loading
    this.windowIsLoading(info);

    child.style.display = 'block';
  }

  /**
   * @description Binds event listeners for the info window
   *
   * @param {Object} marker - Instance of Google Maps Marker class
   * @param {string} content - Content to display in an info window
   * @param {boolean} isMobile - If the user is on a handheld device
   *
   * @return {void}
   */
  bindInfoWindowListeners(marker, content, isMobile) {
    const { google, map } = window;

    // TODO: improve this...
    const getProjection = this.overlay.getProjection();
    this.centerChangedListener = google.maps.event.addListener(map, 'center_changed', () => {
      const pos = getProjection.fromLatLngToContainerPixel(
        marker.getPosition(),
      );
      this.positionInfoWindow(pos, content, isMobile);
    });

    this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', () => {
      try {
        const pos = getProjection.fromLatLngToContainerPixel(
          marker.getPosition(),
        );
        this.positionInfoWindow(pos, content, isMobile);
      } catch (err) {
        // console.log('🔥');
      }
    });
  }

  /**
   * @description Closes the info window
   *
   * @param {Object} charger - Details about charger
   * @param {string|integer} charger.trt_id - Unique identifier for the charger
   *
   * @return {void}
   */
  closeInfoWindow(isMobile) {
    const info = document.getElementById('info-window');
    const windowIsOpen = info.style.display === 'block';
    const windowIsLoading = info.className.indexOf('loading') >= 0;
    try {
      const closeBtn = info.childNodes[0].childNodes[0].childNodes[0];
      closeBtn.removeEventListener('click', this.closeInfoWindow);
    } catch (e) {
      // console.log('💥');
    }

    MapMarkers.resetSelectedMarkers();

    if (!windowIsLoading) {
      if (isMobile && windowIsOpen) {
        const timeout = Enliven.TIMEOUT;
        info.className = 'tsla-two-tip slide-in';
        info.style.transform = 'translate3d(0, 0, 0,)';

        // return to destination charger state
        animateDestinationChargerComponent('CLOSE_INFO_WINDOW');

        // return to directions state
        animateDirectionsComponent('CLOSE_INFO_WINDOW');

        setTimeout(() => {
          info.style.display = 'none';
        }, timeout * 10);
      } else {
        info.style.display = 'none';
      }
    }
  }

  /**
   * @description Opens an info window for a charger
   *
   * @param {boolean} isMobile - If the user is viewing the app on a handheld device
   *
   * @return {void}
   */
  openInfoWindow(isMobile, source) {
    const { map } = window;
    const info = document.getElementById('info-window');

    if (isMobile) {
      // animate info window
      const directionsXPos = Enliven.getTranslateX(DRAGGABLE_DIRECTIONS);
      const destinationXPos = Enliven.getTranslateX(
        DRAGGABLE_DESTINATION_CHARGERS,
      );
      if (directionsXPos === -100 || destinationXPos === -200 || !source) {
        info.className = 'tsla-two-tip slide-out';
        info.style.transform = 'translate3d(-100%, 0, 0)';
        info.style.left = '200%';
        info.style.display = 'block';

        // add loading classname to node so that user cannot close the window while it is loading
        this.windowIsLoading(info);
      }

      // animate directions component draggable component
      if (source !== 'list') animateDirectionsComponent();

      // animate destination charger draggable component
      animateDestinationChargerComponent();
    } else {
      info.style.display = 'block';

      // nudge the map a little bit to make certain the info window is positioned correctly
      map.panBy(0, 1);
    }
  }

  /**
   * @description Adds a `loading` class name to DOM node if the spinner is present
   *
   * @param {Object} node - DOM node to search for <div class="section-loader"></div>
   *
   * @return {void}
   */
  windowIsLoading(node) {
    const info = node;
    const content = info.firstElementChild.innerHTML;
    if (
      content === '<div class="section-loader"></div>' &&
      info.className.indexOf('loading') === -1
    ) {
      info.className += ' loading';
    } else {
      info.className = info.className.replace('loading', '');
    }
  }

  /**
   * @description Triggers a click event to open an info window
   *
   * @param {Object} charger - Details about charger
   * @param {string|integer} charger.trt_id - Unique identifier for the charger
   *
   * @return {void}
   */
  handleOpenChargerWindow(charger) {
    /* eslint-disable no-new */
    const { google } = window;
    const coords = new google.maps.LatLng(
      charger.location.lat,
      charger.location.lng,
    );
    const { markers } = MapMarkers;
    const Trigger = google.maps.event.trigger;
    new Trigger(markers[charger.trt_id], 'click', {
      latLng: coords,
      source: LIST,
    });
  }
}

export default new MapWindow();
